import Hero from './Hero';
import GallerySection from './GallerySection';
import HowItWorksIndex from './HowItWorksIndex';
import CreatorFlipCards from './CreatorFlipCards';
import WhyUsIndex from './WhyUsIndex';
import CTAIndex from './CTAIndex';

/**
 * Landing page: Hero -> social proof -> how it works -> examples -> trust -> CTA.
 */
export default function LandingPage() {
  return (
    <>
      <Hero />
      <GallerySection />
      <HowItWorksIndex />
      <CreatorFlipCards />
      <WhyUsIndex />
      <CTAIndex />
    </>
  );
}
